import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { IAppConfig } from '../models/app-config';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {

    private _settings: IAppConfig;

    public get settings(): IAppConfig {
        return this._settings;
    }

    constructor(
        private http: HttpClient) {

    }

    public load = (): Promise<IAppConfig> => {
        const jsonFile = `assets/config/config.${environment.name}.json`;
        return new Promise<IAppConfig>((resolve, reject) => {
            this.http.get(jsonFile).toPromise().then((response : IAppConfig) => {
                this._settings = response;
                this._settings.version = JSON.parse(localStorage.getItem('Version'));
                resolve(this.settings);
            }).catch((response: any) => {
                reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}
